export enum ControlFlowCustomNode {
    BinaryExpressionFunctionNode = 'BinaryExpressionFunctionNode',
    BlockStatementControlFlowFlatteningNode = 'BlockStatementControlFlowFlatteningNode',
    CallExpressionControlFlowStorageCallNode = 'CallExpressionControlFlowStorageCallNode',
    CallExpressionFunctionNode = 'CallExpressionFunctionNode',
    ControlFlowStorageNode = 'ControlFlowStorageNode',
    ExpressionWithOperatorControlFlowStorageCallNode = 'ExpressionWithOperatorControlFlowStorageCallNode',
    LogicalExpressionFunctionNode = 'LogicalExpressionFunctionNode',
    StringLiteralControlFlowStorageCallNode = 'StringLiteralControlFlowStorageCallNode',
    StringLiteralNode = 'StringLiteralNode'
}
